import { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { TOrderTechnicalLog } from 'src/types/orders';
import { formatDate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  index: number;
  log?: TOrderTechnicalLog;
  select: (index: number | null) => void;
  selected: boolean;
}

export default class OrderTechnicalLogItem extends Component<IProps> {
  setLogCaseClose = () => {
    this.props.select(this.props.selected ? null : this.props.index);
  };

  render() {
    return (
      <div key={this.props.index} className={`order-techlog-item d-flex flex-column mb-2 ${!this.props.selected ? '' : 'bg-graysoft mb-4'}`}>
        <button className="d-flex flex-row align-items-center justify-content-between p-2" onClick={this.setLogCaseClose}>
          <div className="d-flex flex-column align-items-start">
            <p className="family-medium color-dark text-size-18 pb-2">
              {localeStore.t('txt_delivery_status_h')}:&nbsp;{this.props.log?.status || <Skeleton width={150} />}
            </p>
            <p className="family-medium color-dark text-size-18">
              {localeStore.t('txt_Date')}:&nbsp;
              {this.props.log ? formatDate(this.props.log.time * 1000, { includeSecond: true, militaryFormat: true }) : <Skeleton width={150} />}
            </p>
          </div>
          <Icon
            name={!this.props.selected ? Icons.Chevron : Icons.Close}
            className={`color-gray2 icon-techlog ${!this.props.selected ? 'text-size-24' : ''}`}
          />
        </button>
        {this.props.selected ? (
          <div className="order-techlog-item__log family-regilar text-size-14 bg-white p-2 mt-1 mx-2 mb-2">
            {this.props.log ? JSON.stringify(this.props.log.json, null, 2) : null}
          </div>
        ) : null}
      </div>
    );
  }
}
